import { z } from "zod";

const labelMapSchema = z.record(z.string(), z.string());
const stringChipListSchema = z.array(
  z.object({
    code: z.string(),
    label: z.string(),
    emoji: z.string().optional(),
  }),
);

export const catalogResponseSchema = z.object({
  positions: stringChipListSchema,
  employmentTypes: stringChipListSchema,
  salaryTypes: stringChipListSchema,
  availableFromOptions: stringChipListSchema,
  experienceDurations: stringChipListSchema,
  venueTypes: stringChipListSchema,
  livingArrangements: stringChipListSchema,
  educationLevels: stringChipListSchema,
  provinces: stringChipListSchema,
  genders: stringChipListSchema,
  benefits: stringChipListSchema,
  advantages: stringChipListSchema,
  /** Skills grouped by primary position cho UX form post job filter theo position */
  skillsByPosition: z.record(
    z.string(),
    z.array(z.object({ code: z.string(), label: z.string() })),
  ),
  /** Flat list cho worker profile chip catalog */
  allSkills: z.array(z.object({ code: z.string(), label: z.string() })),
  bioTemplates: z.array(
    z.object({
      id: z.string(),
      label: z.string(),
      template: z.string(),
    }),
  ),
  postTemplates: z.array(
    z.object({
      code: z.string(),
      label: z.string(),
      emoji: z.string(),
      position: z.string(),
      venueType: z.string(),
      employmentType: z.string(),
      salaryMin: z.number(),
      salaryMax: z.number(),
      salaryType: z.string(),
      defaultHeadcount: z.number(),
      title: z.string(),
      description: z.string(),
      benefits: z.array(z.string()),
      skillsRequired: z.array(z.string()),
      skillsPreferred: z.array(z.string()),
      reqGender: z.string().nullable().optional(),
      reqMinAge: z.number().int().nullable().optional(),
      reqMaxAge: z.number().int().nullable().optional(),
      reqMinHeightCm: z.number().int().nullable().optional(),
      reqMotorbikeRequired: z.boolean().optional(),
      reqExcludeVisibleTattoo: z.boolean().optional(),
      reqKycCccdRequired: z.boolean().optional(),
    }),
  ),
});

export type CatalogResponse = z.infer<typeof catalogResponseSchema>;

// Re-export label maps available too
export { labelMapSchema };
